/* Mood Sound Collection refresh: one shared demo player for the homepage cards, the record animation,
   the now-playing bar, add-to-cart from cards (opens the theme's cart drawer) and the style filters. */
(function () {
  if (window.MSC) return;
  var audio = new Audio();
  audio.preload = 'none';
  var current = null;   // { id, title, img, url, variant, price }
  var ours = false;     // true while we tell the theme's own players to pause

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function fmt(s) { if (!isFinite(s) || s < 0) s = 0; var m = Math.floor(s / 60), r = Math.floor(s % 60); return m + ':' + (r < 10 ? '0' : '') + r; }
  function mark(id, on) { $all('[data-msc-id="' + id + '"]').forEach(function (el) { el.classList.toggle('is-playing', on); }); }

  // ---- now playing bar ----
  var bar = document.createElement('div');
  bar.className = 'msc-now';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Now playing');
  bar.innerHTML =
    '<div class="msc-now__in">' +
    '<img alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACw=">' +
    '<div class="msc-now__t"><small>Now playing · demo</small><a href="#"></a></div>' +
    '<button type="button" class="msc-play" data-msc-toggle aria-label="Pause">' +
    '<svg class="msc-i-play" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4.5v15l12.5-7.5z"/></svg>' +
    '<svg class="msc-i-pause" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg></button>' +
    '<button type="button" class="msc-btn msc-btn--red" data-msc-add=""><span class="msc-now__lbl">Add to cart ·&nbsp;</span><b></b></button>' +
    '</div>';
  function paintBar() {
    if (!current) return;
    bar.querySelector('img').src = current.img || '';
    var a = bar.querySelector('.msc-now__t a'); a.textContent = current.title || ''; a.href = current.url || '#';
    var add = bar.querySelector('[data-msc-add]'); add.setAttribute('data-msc-add', current.variant || '');
    add.querySelector('b').textContent = current.price || '';
    add.hidden = !current.variant;
    bar.classList.toggle('is-playing', !audio.paused);
    bar.querySelector('[data-msc-toggle]').setAttribute('aria-label', audio.paused ? 'Play' : 'Pause');
  }

  // ---- playing ----
  function play(btn) {
    var holder = btn.closest('[data-msc-id]');
    var id = holder && holder.getAttribute('data-msc-id');
    var url = btn.getAttribute('data-msc-play');
    if (!id || !url) return;
    if (current && current.id === id) { if (audio.paused) audio.play().catch(function () {}); else audio.pause(); return; }
    if (current) mark(current.id, false);
    ours = true; document.body.dispatchEvent(new CustomEvent('pauseAllMedia')); ours = false;
    current = { id: id, url: btn.getAttribute('data-msc-url'), title: btn.getAttribute('data-msc-title'), img: btn.getAttribute('data-msc-img'),
      variant: btn.getAttribute('data-msc-variant'), price: btn.getAttribute('data-msc-price') };
    audio.src = url;
    audio.play().catch(function () { mark(id, false); });
  }
  audio.addEventListener('play', function () { if (!current) return; mark(current.id, true); bar.classList.add('is-on'); paintBar(); });
  audio.addEventListener('pause', function () { if (!current) return; mark(current.id, false); paintBar(); });
  audio.addEventListener('ended', function () { if (!current) return; mark(current.id, false); paintBar(); });
  // no demo file for this pack: drop its play buttons instead of leaving a dead one
  audio.addEventListener('error', function () {
    if (!current) return;
    mark(current.id, false); bar.classList.remove('is-on');
    $all('[data-msc-id="' + current.id + '"] [data-msc-play]').forEach(function (b) { b.style.display = 'none'; });
    current = null;
  });
  audio.addEventListener('timeupdate', function () {
    if (!current) return;
    var pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
    $all('[data-msc-id="' + current.id + '"] [data-msc-progress]').forEach(function (el) { el.style.width = pct + '%'; });
    $all('[data-msc-id="' + current.id + '"] [data-msc-time]').forEach(function (el) { el.textContent = fmt(audio.currentTime) + ' / ' + fmt(audio.duration); });
  });
  // the theme's own players ask everything else to stop
  document.body.addEventListener('pauseAllMedia', function () { if (!ours) audio.pause(); });

  // ---- the theme's product page player: the main cover becomes a record stage ----
  var host = null;
  function setupPdp() {
    if (!document.body.classList.contains('template-product')) return;
    var w = document.querySelector('[data-product-image-wrapper]');
    if (!w) return;
    host = w;
    w.classList.add('msc-pdp-host');
    var img = w.querySelector('img[data-product-featured-image]');
    var rec = document.createElement('div');
    rec.className = 'msc-rec';
    rec.setAttribute('aria-hidden', 'true');
    rec.innerHTML = '<div class="msc-rec__spin"><div class="msc-rec__label"></div></div>';
    w.insertBefore(rec, w.firstChild);
    var label = function () { var src = img && (img.currentSrc || img.src); if (src) rec.querySelector('.msc-rec__label').style.backgroundImage = 'url("' + src + '")'; };
    if (img) { img.addEventListener('load', label); label(); }
  }
  var origPlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function () {
    var el = this;
    if (el !== audio && !el._msc) {
      el._msc = true;
      el.addEventListener('play', function () { if (host) host.classList.add('is-playing'); });
      el.addEventListener('pause', function () { if (host) host.classList.remove('is-playing'); });
      el.addEventListener('ended', function () { if (host) host.classList.remove('is-playing'); });
    }
    return origPlay.apply(el, arguments);
  };

  // ---- add to cart: the theme refreshes and opens its drawer on this event ----
  function add(btn) {
    var v = parseInt(btn.getAttribute('data-msc-add'), 10);
    if (!v) return;
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: v, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        document.body.dispatchEvent(new CustomEvent('label:modalcart:afteradditem'));
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
      })
      .catch(function () { window.location.href = '/cart/add?id=' + v + '&quantity=1'; })
      .then(function () { btn.disabled = false; });
  }

  // ---- style filters + show all ----
  function filter(chip) {
    var root = chip.closest('[data-msc-catalog]'); if (!root) return;
    var f = chip.getAttribute('data-msc-filter');
    root.setAttribute('data-filter', f);
    $all('[data-msc-filter]', root).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
    layout(root);
  }
  function layout(root) {
    var f = root.getAttribute('data-filter') || 'all';
    var phone = window.matchMedia('(max-width: 560px)').matches;
    var limit = parseInt(root.getAttribute(phone ? 'data-limit-mobile' : 'data-limit'), 10) || parseInt(root.getAttribute('data-limit'), 10) || 12;
    // "Show more" adds one row at a time; a row is however many columns the grid has right now
    var grid = root.querySelector('.msc-grid');
    var cols = grid ? getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length : 1;
    limit += (parseInt(root.getAttribute('data-rows'), 10) || 0) * Math.max(1, cols);
    // the hero card already shows this pack, so the grid leaves it out
    var skip = root.getAttribute('data-skip');
    var shown = 0, matches = 0;
    $all('.msc-card', root).forEach(function (card) {
      var hit = card.getAttribute('data-msc-id') !== skip &&
        (f === 'all' || (' ' + card.getAttribute('data-collections') + ' ').indexOf(' ' + f + ' ') >= 0);
      if (hit) matches++;
      var show = hit && (f !== 'all' || shown < limit);
      card.hidden = !show;
      if (show) shown++;
    });
    var more = root.querySelector('[data-msc-more]');
    if (more) {
      var base = parseInt(root.getAttribute(phone ? 'data-limit-mobile' : 'data-limit'), 10) || 12;
      var allShown = matches <= limit;
      more.hidden = f !== 'all' || matches <= base;
      more.textContent = allShown ? 'Show fewer' : 'Show more';
      more.setAttribute('data-msc-fewer', allShown ? 'true' : 'false');
      more.setAttribute('aria-expanded', allShown ? 'true' : 'false');
    }
    var count = root.querySelector('[data-msc-count]');
    if (count) count.textContent = matches + (matches === 1 ? ' release' : ' releases');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-msc-play],[data-msc-add],[data-msc-filter],[data-msc-more],[data-msc-toggle]');
    // a click on a cover plays its demo, or opens the pack when it has none (Clarity: covers were dead clicks)
    if (!t) {
      var cover = e.target.closest('.msc-vinyl');
      var holder = cover && cover.closest('[data-msc-id]');
      if (!holder) return;
      var btn = holder.querySelector('[data-msc-play]');
      if (btn && btn.style.display !== 'none') t = btn;
      else {
        var link = holder.querySelector('a[href*="/products/"]');
        if (link) window.location.href = link.href;
        return;
      }
    }
    if (t.hasAttribute('data-msc-play')) { e.preventDefault(); play(t); }
    else if (t.hasAttribute('data-msc-add')) { e.preventDefault(); add(t); }
    else if (t.hasAttribute('data-msc-filter')) { e.preventDefault(); filter(t); }
    else if (t.hasAttribute('data-msc-more')) {
      e.preventDefault();
      var r = t.closest('[data-msc-catalog]');
      var fewer = t.getAttribute('data-msc-fewer') === 'true';
      r.setAttribute('data-rows', fewer ? 0 : (parseInt(r.getAttribute('data-rows'), 10) || 0) + 1);
      layout(r);
      // after "Show fewer" the page gets much shorter, so bring the button back into view
      if (fewer) t.scrollIntoView({ block: 'center' });
    }
    else if (t.hasAttribute('data-msc-toggle')) { e.preventDefault(); if (audio.paused) audio.play().catch(function () {}); else audio.pause(); }
  });

  // ---- hero: as the page scrolls, the heading lines part and the small line swipes in (--p goes 0 to 1) ----
  function heroReveal() {
    var stacks = $all('[data-msc-reveal]');
    if (!stacks.length) return;
    var queued = false;
    function set() {
      queued = false;
      var p = Math.min(1, Math.max(0, window.scrollY / (window.innerHeight * 0.14)));
      stacks.forEach(function (s) { s.style.setProperty('--p', p.toFixed(3)); });
    }
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(set); } }, { passive: true });
    set();
  }

  function init() {
    if (!bar.parentNode) document.body.appendChild(bar);
    $all('[data-msc-catalog]').forEach(layout);
    setupPdp();
    heroReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { $all('[data-msc-catalog]').forEach(layout); });
  var phoneQuery = window.matchMedia('(max-width: 560px)');
  if (phoneQuery.addEventListener) phoneQuery.addEventListener('change', function () { $all('[data-msc-catalog]').forEach(layout); });
  window.MSC = { audio: audio };
})();
